import get from 'lodash/get';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import { METRICS_STANDARDS } from 'modules/App/constants';
function getTargetRangeForPhi(targetRanges) {
    if (!targetRanges) {
        return {};
    }
    return {
        preMeal: {
            lowThreshold: targetRanges.glucosePreMealLow,
            highThreshold: targetRanges.glucosePreMealHigh
        },
        postMeal: {
            lowThreshold: targetRanges.glucosePostMealLow,
            highThreshold: targetRanges.glucosePostMealHigh
        },
        critical: {
            lowThreshold: targetRanges.glucoseCriticalLow,
            highThreshold: targetRanges.glucoseCriticalHigh
        }
    };
}
function removeEmptyRange(standard, range) {
    if (standard && standard[range]) {
        Object.keys(standard[range]).forEach((k)=>!standard[range][k] && standard[range][k] !== undefined && delete standard[range][k]);
    }
}
function standardMerge(newStandards, baseStandards) {
    let baseCopy = baseStandards && cloneDeep(baseStandards);
    const newCopy = cloneDeep(newStandards);
    baseCopy = merge(newCopy, baseCopy);
    removeEmptyRange(baseCopy, 'preMeal');
    removeEmptyRange(baseCopy, 'postMeal');
    removeEmptyRange(baseCopy, 'critical');
    baseCopy.preMeal = merge(newCopy.preMeal, baseCopy.preMeal);
    baseCopy.postMeal = merge(newCopy.postMeal, baseCopy.postMeal);
    baseCopy.critical = merge(newCopy.critical, baseCopy.critical);
    return baseCopy;
}
export function getStandards(phiSet, countrySettings, clinicSettings, isAGP = false) {
    if (isAGP) {
        return METRICS_STANDARDS.bloodGlucoseConcentration;
    }
    let standards;
    if (phiSet && phiSet.glucoseLevelTargets) {
        standards = phiSet.glucoseLevelTargets;
    }
    const diabetesType = get(phiSet, 'diabetesType');
    if (clinicSettings && clinicSettings.glucoseRanges && clinicSettings.glucoseRanges[diabetesType]) {
        standards = standardMerge(clinicSettings.glucoseRanges[diabetesType], standards);
    }
    if (countrySettings && countrySettings.glucoseRanges && countrySettings.glucoseRanges[diabetesType]) {
        standards = standardMerge(countrySettings.glucoseRanges[diabetesType], standards);
    }
    if (clinicSettings && clinicSettings.glucoseRanges && clinicSettings.glucoseRanges.Default) {
        standards = standardMerge(clinicSettings.glucoseRanges.Default, standards);
    }
    if (countrySettings && countrySettings.glucoseRanges && countrySettings.glucoseRanges.Default) {
        standards = standardMerge(countrySettings.glucoseRanges.Default, standards);
    }
    if (clinicSettings) {
        standards = standardMerge(getTargetRangeForPhi(clinicSettings), standards);
    }
    if (countrySettings) {
        standards = standardMerge(getTargetRangeForPhi(countrySettings), standards);
    }
    standards = standardMerge(METRICS_STANDARDS.bloodGlucoseConcentration, standards);
    return standards;
}
